import React from "react";
import TaskBoard from "../TodoList/TaskBoard";


export const TasksListing = () => {
    // admintaskListing
    return(
        <TaskBoard access="admin" type="tasks" />
    )
}